
import React , { useState } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { SplitButton } from 'primereact/splitbutton';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Card } from 'primereact/card';
import SearchView from './SearchView';


import { ApiCallPost } from '../ApiCall/ApiCall';



export default function Search() {

    const [numTel,setNumTel] = useState("")
    const [data,setData] = useState([])


    function onBuscar() {
        console.log("onBuscar")

        ApiCallPost("search", { "numtel": numTel } )
        .then( response =>{

            //console.log( "Response = ", response )

            setData( response )
            return ;

        } )
        .catch( error =>{

            console.log("Error = ", error)

        })
    }

    function onChangeNumber( e ) {
        console.log( "onChangeNumber", e.target.value )

        setNumTel( e.target.value )
    }

    const items = [
        {
            label: 'Update',
            icon: 'pi pi-refresh'
        },
        {
            label: 'Delete',
            icon: 'pi pi-times'
        }
    ];

    const startContent = (
        <React.Fragment>
            <Button icon="pi pi-plus" className="mr-2" />
            <Button icon="pi pi-print" className="mr-2" />
            <Button icon="pi pi-upload" />
        </React.Fragment>
    );

    const centerContent = (
        <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText placeholder="Buscar por Numero"  onChange={onChangeNumber}/>
        </IconField>
    );

    const endContent = (
        <React.Fragment>
            <SplitButton label="Buscar" model={items} icon="pi pi-check" onClick={onBuscar}></SplitButton>
        </React.Fragment>
    );

    return (
        <div className="card">
                        <div className="card">
                            <Card title="Buscar Registro">
                                <p className="m-0">
            
                                    Buscar Registro por número telefónico
                                </p>
                            </Card>
                        </div>
            <Toolbar start={startContent} center={centerContent} end={endContent} />

            <SearchView data={data}></SearchView>
        </div>
    );
}
        